export default {"src":"/_next/static/media/discord.4f2f5949.svg","height":96,"width":127};